import React from 'react';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import { useT } from '../../../i18n';
import { FormFooter, SaveButton } from './ui';

interface FormActionsProps {
  /** Permiso que habilita "Guardar" (canCreate en altas, canUpdate en ediciones…). */
  allowed: boolean;
  deniedTooltip: string;
  onSave: () => void;
  /** Ruta del listado (página) o acción de cerrar (modal). */
  cancelTo?: string;
  onCancel?: () => void;
  saveLabel?: string;
  disabled?: boolean;
  loading?: boolean;
}

/** Pie de formulario estándar, abajo a la derecha: "Cancelar" (borde) y "Guardar" (con permiso). */
const FormActions: React.FC<FormActionsProps> = ({ allowed, deniedTooltip, onSave, cancelTo, onCancel, saveLabel, disabled, loading }) => {
  const t = useT();
  return (
    <FormFooter>
      {cancelTo ? (
        <Button variant="outlined" color="inherit" component={Link} to={cancelTo}>
          {t('common.cancel')}
        </Button>
      ) : (
        <Button variant="outlined" color="inherit" onClick={onCancel}>
          {t('common.cancel')}
        </Button>
      )}
      <SaveButton allowed={allowed} deniedTooltip={deniedTooltip} onClick={onSave} disabled={disabled} loading={loading}>
        {saveLabel ?? t('common.save')}
      </SaveButton>
    </FormFooter>
  );
};

export default FormActions;
